import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  OnInit,
  output,
} from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';

import { ButtonComponent, DatePickerComponent } from '@rp/shared/components';
import { TranslateModule } from '@ngx-translate/core';
import { FormUtils } from '@rp/utils';
import { debounceTime, distinctUntilChanged, filter } from 'rxjs';
import { FILTER_DELAY } from '@rp/shared/models';
import { isEqual } from 'lodash';

import { PayoutWebmasterFilter } from '../../models';

@Component({
  selector: 'rp-filters-webmaster',
  standalone: true,
  templateUrl: './filters-webmaster.component.html',
  styleUrl: './filters-webmaster.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonComponent, DatePickerComponent, TranslateModule, ReactiveFormsModule, RouterLink],
})
export class FiltersWebmasterComponent implements OnInit {
  form = new FormGroup({
    range: new FormControl({
      startDate: null,
      endDate: null,
    }),
  });

  isFormEmpty = FormUtils.isFormEmpty;

  filterChanged = output<PayoutWebmasterFilter>();

  private _destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    this.form.valueChanges
      .pipe(
        debounceTime(FILTER_DELAY),
        distinctUntilChanged((prev, curr) => isEqual(prev, curr)),
        filter(() => this.form.valid),
        takeUntilDestroyed(this._destroyRef),
      )
      .subscribe(() => this.filterChanged.emit(<PayoutWebmasterFilter>this.form.value));
  }
}
